// Utilities
import { PlannerTheme } from "@ms/uno-constants/lib/local/ThemeConstants";
export function isLightTheme(theme) {
    switch(theme.name){
        case PlannerTheme.Light:
            return true;
        case PlannerTheme.Dark:
        case PlannerTheme.HighContrast:
        default:
            return false;
    }
}
export function isDarkTheme(theme) {
    switch(theme.name){
        case PlannerTheme.Dark:
            return true;
        case PlannerTheme.Light:
        case PlannerTheme.HighContrast:
        default:
            return false;
    }
}
export function isDarkOrHcTheme(theme) {
    return theme.name === PlannerTheme.Dark || theme.name === PlannerTheme.HighContrast;
}
